let $burger
    , $menuPanel
    , $figure
    , $body
    , $html
    , $links

export function init() {
    $burger = jQuery("#burger")
    $menuPanel = jQuery("#top-bar-panel")
    $links = jQuery("#top-bar-panel .menu-item a")
    $figure = jQuery("#top-bar-panel figure")
    $body = jQuery("body")
    $html = jQuery("html")

    handleMenu()
    // hoverLinksAnim()
}

function handleMenu() {
    if (!$burger) return


    $html.on("click", (e) => {
        console.log('default click');
        closeMenu()
    })

    $burger.on("click", (e) => {
        e.stopPropagation()
        toggleMenu(e)
    })

    $links.on("click", (e) => {
        e.stopPropagation()
    })
}

function toggleMenu(e) {
    if (!$menuPanel) return

    if ($burger.hasClass("open")) {
        console.log(`Menu open`)
        closeMenu()
    } else {
        console.log(`Menu closed`)
        openMenu()
    }
}
function openMenu() {
    console.log(`Menu opening`)
    $burger.add($menuPanel).add($body).addClass("open")
}

function closeMenu() {
    console.log(`Menu closing`)
    $burger.add($menuPanel).add($body).removeClass("open")
}

function hoverLinksAnim() {
    $links.on("hover", link => {
        pos1 = link.getAttr("pos1")
        pos2 = link.getAttr("pos2")
        pos3 = link.getAttr("pos3")

        $paths = $figure.find("path")

        $paths.forEach(path, i => {
            path.css({
                transform: `translate(${x}, ${y})`
            })
        })
    })

    // $links.forEach($link, i => {
    //     $paths = $figure.find("path")
    //     $paths.forEach(path => {

    //     });
    // });
}